export default "__VITE_ASSET__60d9Gl4I__"